import { Button, Card, CardBody } from "@heroui/react";
import { LuX, LuCheck } from "react-icons/lu";

const FilterCard = ({ children, onClear, onApply, isVisible = true }) => {
    if (!isVisible) return null;

    return (
        <Card className="border-default-200 border" shadow="none">
            <CardBody className="gap-4">
                {/* Filter Content */}
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                    {children}
                </div>

                {/* Action buttons */}
                <div className="flex items-center justify-end gap-2 pt-4">
                    <Button
                        size="sm"
                        variant="light"
                        color="danger"
                        startContent={<LuX size={14} />}
                        onPress={onClear}
                    >
                        Hapus Filter
                    </Button>
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<LuCheck size={14} />}
                        onPress={onApply}
                    >
                        Terapkan
                    </Button>
                </div>
            </CardBody>
        </Card>
    );
};

export default FilterCard;
